var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"disabled":_vm.disable},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v("mdi-thumb-up")])}
var staticRenderFns = []

export { render, staticRenderFns }